
const table = {
  label: {
    index: "序号",
    account: "账号",
    iccid:"iccid卡号",
    imei:'imei',
    whether:'是否终身免费',
    terminalAccount:"终端账号",
    terminalName:"终端名称",
    status: "状态",
    name: "名称",
    isOnline: "在线状态",
    yes:"是",
    no:"否",
    balance: "QB余额",
    vBalance: "虚拟货币余额",
    operate: "操作",
    createTime: "创建时间",
    enableTime: "启用日期",
    expiredTime:'Q币到期时间',
    maturityTime: "到期时间",
    OrderMaturityTime:'订单到期时间',
    modifyTime: "修改时间",
    domainName: "域名",
    logEventType:'日志类型',
    functions:'功能',
    operatorAccount:'操作人账号',
    operator:'操作人',
    origin:'来源人',
    target:'目标人',
    beoperated :'被操作人',
    beoperatedname:'被操作人名称',
    beoperatedAccount:"被操作人账号",
    operatorRole:'操作人角色',
    originAccount:'来源账号',
    originName:'来源人',
    originRole:'来源角色',
    originBalance:'来源人余额',
    targetName:'目标人',
    targetAccount:'目标账号',
    targetRole:'目标角色',
    targetBalance:'目标余额',
    logInfo:'日志信息',
    orderId: '订单号',
    orderType: '订单类型',
    orderFuncs: '订单功能',
    remark: '备注',
    actNum: '账号数',
    pay:'付款',
    organizationId:'组织id',
    organizationName:'组织名称',
    hierarchy:'组织层级',
    organizationAccount:'组织账号',
    ChangeTheTargetName:"改签目标名称",
    ChangeTheTargetAccount:"改签目标名称",
    owner:"所属有者",//所属有者
    operationType:"操作类型",//操作类型
    originalOrder:"原订单号",//原订单号
    used:"已使用",//已使用
    Unused:"未使用",//未使用
    beforeTalkie:"改前对讲价格",//改前对讲价格
    afterTalkie:"改后对讲价格",//改后对讲价格
    beforeDispatch:"改前调度价格",//改前调度价格
    afterDispatch:"改后调度价格",//改后调度价格
    beforeRecord:"改前录音存储一个月",//改前录音存储一个月
    afterRecord:"改后录音存储一个月",//改后录音存储一个月
    beforeRecord1:"改前录音存储三个月",//改前录音存储三个月
    afterRecord1:"改后录音存储三个月",//改后录音存储三个月
    beforeRecord2:"改前录音存储六个月",//改前录音存储六个月
    afterRecord2:"改后录音存储六个月",//改后录音存储六个月
    beforeRecord3:"改前录音存储一年",//改前录音存储一年
    afterRecord3:"改后录音存储一年",//改后录音存储一年
    beforeLocation:"改前定位存储7天",//改前定位存储7天
    afterLocation:"改后定位存储7天",//改后定位存储7天
    beforeLocation1:"改前定位存储一个月",//改前定位存储一个月
    afterLocation1:"改后定位存储一个月",//改后定位存储一个月
    beforeLocation2:"改前定位存储三个月",//改前定位存储三个月
    afterLocation2:"改后定位存储三个月",//改后定位存储三个月
    beforeLocation3:"改前定位存储六个月",//改前定位存储六个月
    afterLocation3:"改后定位存储六个月",//改后定位存储六个月
    beforeLocation4:"改前定位存储一年",//改前定位存储一年
    afterLocation4:"改后定位存储一年",//改后定位存储一年

    rebateAccount:"返利来源账号",//返利来源账号
    rebateName:"返利来源名称",//返利来源名称
    rebateAmount:"返利金额",//返利金额
    createDate: "创建日期",
    transactionAmount:"交易金额",//交易金额
    originBeforeBalance:"来源人操作前余额",//来源人操作前余额
    originAfterBalance:"来源人操作后余额",//来源人操作后余额
    targetBeforeBalance:"目标人操作前余额",//目标人操作前余额
    targetAfterBalance:"目标人操作后余额",//目标人操作后余额
    paymentDetails:"订单支付详情",//订单支付详情













    proxy: {
      name: "代理名称",
      account: "代理账号",
      enterpriseCount: "企业数量",
      terminalCount: "注册用户",
      useTerminalCount: "使用用户",
      onlineTerminalCount: "在线用户",
      lifelongCount: "终身用户",

      phone:"电话",
      company:"公司",
      groupName:"群组名称",
      groupId:"群组id"
    },
    terminal:{
      id:'终端Id',
      name: "终端名称",
      account: "终端账号",
    },
    enterprise: {
      name: "企业名称",
      account: "企业账号",
      id:'企业id',
    },
    group: {
      name: "名称",
      type: "类型"
    },
    subagen:{
      name: "子代理名称",//代理名称
      account: "子代理账号",//代理账号
      balance: "子代理余额",//余额
    },
  }
};
export default table;



// WEBPACK FOOTER //
// ./src/api/lang/modules/table/table_zh.js